import { render, staticRenderFns } from "./BorderButton.vue?vue&type=template&id=6cd50426&scoped=true&"
import script from "./BorderButton.vue?vue&type=script&lang=js&"
export * from "./BorderButton.vue?vue&type=script&lang=js&"
import style0 from "./BorderButton.vue?vue&type=style&index=0&id=6cd50426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd50426",
  null
  
)

export default component.exports